(() => {
  const reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  if (reduceMotion.matches) return;

  const activeElements = new Set();

  let frameRequested = false;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          activeElements.add(entry.target);
        } else {
          activeElements.delete(entry.target);
        }
      });

      requestUpdate();
    },
    {
      rootMargin: '10% 0px 10% 0px'
    }
  );

  const update = () => {
    const viewportHeight =
      window.innerHeight ||
      document.documentElement.clientHeight;

    activeElements.forEach((element) => {
      const rect = element.getBoundingClientRect();

      const elementCenter =
        rect.top + rect.height / 2;

      const viewportCenter =
        viewportHeight / 2;

      let progress =
        (elementCenter - viewportCenter) /
        (viewportCenter + rect.height / 2);

      progress = Math.max(-1, Math.min(1, progress));

      const amount =
        parseFloat(element.dataset.dljParallax) || 14;

      const y = progress * amount * -1;

      element.style.setProperty(
        '--dlj-parallax-y',
        `${y.toFixed(2)}px`
      );
    });

    frameRequested = false;
  };

  const requestUpdate = () => {
    if (frameRequested) return;

    frameRequested = true;

    window.requestAnimationFrame(update);
  };

  const attach = (root = document) => {
    root
      .querySelectorAll('[data-dlj-parallax]')
      .forEach((element) => {

        if (element.dataset.dljMotionReady === 'true') {
          return;
        }

        element.dataset.dljMotionReady = 'true';

        observer.observe(element);
      });

    requestUpdate();
  };

  attach();

  window.addEventListener(
    'scroll',
    requestUpdate,
    { passive: true }
  );

  window.addEventListener(
    'resize',
    requestUpdate
  );

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      attach(event.target);
    }
  );
})();